<!-- 由 Dioa 创建于 2022-10-21 Friday -->
<template>
  <div
    class="download-pop"
    v-if="downloadShow"
    @click.self="downloadShow = false"
  >
    <div class="download-wrapper animate__animated animate__fadeIn">
      <img :src="shareLink" alt="" class="share-image" />
      <div class="save-btn" @click="onSave">保存图片</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadDialog',

  components: {},

  props: {
    visible: {
      required: true,
      type: Boolean,
      default: () => {
        return false
      }
    },
    shareLink: {
      required: false,
      type: String,
      default: () => {
        return ''
      }
    }
  },

  data() {
    return {
      downloadShow: false
    }
  },

  computed: {},

  watch: {
    visible(val) {
      this.downloadShow = val
    },
    downloadShow(val) {
      this.$emit('update:visible', val)
    }
  },

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    onSave() {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.download-pop {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(#000, 0.3);
  z-index: 99999999;
  overflow: auto;
  .download-wrapper {
    width: 80%;
    max-height: vw(600);
    overflow: auto;

    .share-image {
      width: 100%;
      margin-bottom: 10px;
    }
    .save-btn {
      width: 100%;
      padding: 10px;
      display: flex;
      justify-content: center;
      background-color: #897ffc;
      color: #fff;
      box-sizing: border-box;
      border-radius: vw(4);
      font-size: vw(14);
    }
  }
}
</style>
